import React, { useEffect, useState } from 'react';
import styles from './NewsPage.module.scss';
import { useNavigate } from 'react-router-dom';
import LoaderButton from '../../Molecules/Loader/LoaderButton';
import NewsTopHeader from '../../Molecules/TableTopHeader/NewsTopHeader';
import NewsCard from '../../Molecules/NewsAndEvents/NewsCard';
import { useFetchNews } from '../../../Hooks/News';
import TablePagination from '../../Molecules/Pagination/TablePagination';
import ActivityHeader from '../../Molecules/NewsAndEvents/ActivityHeader';
import Loader from '../../Molecules/Loader/Loader';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';

const NewsPage = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [search, setSearch] = useState('');

  const {
    data: news,
    refetch: refetchNews,
    isLoading,
  } = useFetchNews({
    pageSize: pageSize,
    pageNumber: page,
    year: '',
    selectedActivity: selectedActivity,
    searchKey: search,
  });
  const itemsPerPage = news?.data?.pageSize;
  const totalItems = news?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate('/home/add-news');
  };

  useEffect(() => {
    refetchNews();
  }, [page, pageSize, selectedActivity, search]);

  return (
    <div>
      <NewsTopHeader
        handleNewClick={handleNavigate}
        search={search}
        setSearch={setSearch}
      />
      <ActivityHeader
        selectedActivity={selectedActivity}
        setSelectedActivity={setSelectedActivity}
      />
      <div className={styles['table-container']}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {news?.data?.items?.length > 0 ? (
              <div
                className={`${styles['major-box-grid']} ${
                  news?.data?.items?.length < 3 ? styles['smaller-grid'] : ''
                }`}
              >
                {news?.data?.items.map((program, index) => (
                  <NewsCard
                    program={program}
                    refetchNews={refetchNews}
                    key={index}
                  />
                ))}
              </div>
            ) : (
              <NoDataComponent text='No News' />
            )}
          </>
        )}
        <TablePagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
          itemsPerPage={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default NewsPage;
